import React from "react";
import "./index.scss";
import LoaderUI from "../../../../components/common/loader";

const StatBox = (
	{
		label = '',
		todayData = '',
		yesterdayData = '',
		profit = '',
		text = '',
		icon = false,
		custom = false,
		iconColor = '',
		className = '',
		value,
		second = false,
		loading = true
	}
) => {

	if(todayData === yesterdayData){
		profit = "no change in"
		icon = false;
		iconColor = "text-success";
	}else if(!todayData){
		profit = 100;
		iconColor = "text-danger";
		custom = true;
	}else if(!yesterdayData){
		profit = 100
		iconColor = "text-success";
		custom = false;
	}else{
		profit = (todayData - yesterdayData) * 100 / yesterdayData
		if(profit > 0) {
			iconColor = "text-success";
			custom = false;
			profit = Math.abs(profit).toFixed(2)
		}else {
			iconColor = "text-danger";
			custom = true;
			profit = Math.abs(profit).toFixed(2)
		}
	}

	return (
		<>
			<div className={`stats-box card card-body d-flex flex-column ${className}`}>
				<h2>{label}</h2>
				{loading ? <LoaderUI FullWindow={false} inContainer /> :
					<>
						<div className="info">
							<label>{value ? value : second ? todayData ? Math.abs(todayData).toFixed(2) + 's' : 0 + 's' : todayData}</label>
							<span className="value ">
								<span className={`status  ${iconColor}`}>
									{!value ? profit + '%' : ''}
									{
										icon ?
											<span className={`icon  d-inline-flex ${custom ? 'down-custom' : ''}`}>
												<svg xmlns="http://www.w3.org/2000/svg" width="8.22" height="12.807" viewBox="0 0 8.22 12.807"><path id="up-arrow" d="M115.72,10.7l-4.11,4.11L107.5,10.7l.867-.867L111,12.468V2h1.226V12.453l2.623-2.623Z" transform="translate(-107.5 -2)"></path></svg>
											</span>
											: null
									}

								</span>
								<span className="lbl">
									{text}
								</span>
							</span>
						</div>
						<div className="graph mt-auto">
							<img className="img-fluid" src={require('../../../../assets/img/icons/garph-line.svg')} alt="Graph" />
						</div>
					</>
				}
			</div>
		</>
	);

}
export default StatBox;